import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const CardsWrapper = styled.div<{ isOpen: boolean }>`
	position: relative;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(371px, 1fr));

	/* TODO ?? баг или фича ?? при разрешении от 1200 до 1365 (1366) (470px) px компонент CardRemark скрывается из-за недостаточной (470px) высоты блока */
	height: ${({ isOpen }) => (isOpen ? `max-content` : '400px')};
	overflow: hidden;
	column-gap: 33px;

	${media.laptop} {
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		column-gap: 20px;
	}

	${media.tablet} {
		grid-template-columns: 1fr;
		height: max-content;
		padding-bottom: 0;
		overflow: visible;
	}
`;

export const ShadowBlock = styled.div<{ isOpen: boolean }>`
	position: relative;
	display: flex;

	&::before {
		position: absolute;
		bottom: 32px;
		display: block;
		width: 100%;
		height: ${({ isOpen }) => (isOpen ? '0' : '70px')};
		background: linear-gradient(
			180deg,
			rgb(255 255 255 / 0.01%) 0.61%,
			rgb(255 255 255 / 81.3%) 37.33%,
			#fff 100%
		);
		content: '';
	}

	${media.tablet} {
		display: none;
	}
`;

export const ButtonStyles = css`
	width: 70px !important;
	height: 32px !important;
	margin: 0 auto;
`;
